/**
 *  @class
 *  @function TabbedShowcase
 *  Handles tabbed showcase with CSS scroll carousel
 */

if (!customElements.get('tabbed-showcase')) {
  class TabbedShowcase extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.initializeTabs();
        if (Shopify.designMode) {
          this.setupDesignModeListeners();
        }
      }, 20);
    }

    initializeTabs() {
      this.tabs = Array.from(this.querySelectorAll('button'));
      this.wrapper = this.closest('.tabbed-products-showcase__wrapper');
      this.contentContainer = this.wrapper?.querySelector('.tabbed-products-showcase__content');

      if (!this.tabs.length || !this.contentContainer) {
        return;
      }

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          if (tab.classList.contains('active')) return;
          this.switchToTab(index);
        });
      });

      const panes = this.contentContainer.querySelectorAll('.tabbed-products-showcase__pane');
      panes.forEach(pane => this.setupCarouselArrows(pane));
    }

    switchToTab(index) {
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === index);
      });

      if (this.contentContainer) {
        const panes = this.contentContainer.querySelectorAll('.tabbed-products-showcase__pane');
        panes.forEach((pane, i) => {
          pane.classList.toggle('active', i === index);
          if (i === index) {
            const carousel = pane.querySelector('.tabbed-products-showcase__products');
            if (carousel) carousel.scrollLeft = 0;
          }
        });
      }
    }

    setupCarouselArrows(pane) {
      const carousel = pane.querySelector('.tabbed-products-showcase__products');
      const prevBtn = pane.querySelector('.flickity-prev');
      const nextBtn = pane.querySelector('.flickity-next');

      if (!carousel || !prevBtn || !nextBtn) return;

      const scrollPrev = () => carousel.scrollBy({ left: -carousel.offsetWidth, behavior: 'smooth' });
      const scrollNext = () => carousel.scrollBy({ left: carousel.offsetWidth, behavior: 'smooth' });

      prevBtn.addEventListener('click', scrollPrev);
      prevBtn.addEventListener('keyup', (e) => { if (e.key === 'Enter' || e.key === ' ') scrollPrev(); });
      nextBtn.addEventListener('click', scrollNext);
      nextBtn.addEventListener('keyup', (e) => { if (e.key === 'Enter' || e.key === ' ') scrollNext(); });
    }

    setupDesignModeListeners() {
      this.addEventListener('shopify:block:select', (event) => {
        const clickedTab = event.target.closest('button');
        if (clickedTab) {
          const index = this.tabs.indexOf(clickedTab);
          if (index !== -1) {
            this.switchToTab(index);
          }
        }
      });
    }
  }

  customElements.define('tabbed-showcase', TabbedShowcase);
}
